import React, { useState } from "react";
import { TextField, Grid, Paper, Button, Backdrop, CircularProgress, Alert, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from "./MaterialNotifyComponent";
import { withRouter } from 'react-router-dom';
import { getUserProfile } from "../utils/userProfile";

function CustomerAddToolsSerialForm(props) {
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [serialCode, setSerialCode] = useState('');
    const [customerType, setCustomerType] = useState(0);

    const formElementStyle = {
        margin: "10px 0",
        backgroundColor: '#0072bc'
    };

    const formButtonElementStyle = {
        margin: "10px 0",
        backgroundColor: '#014171',
        fontSize: 'x-large',
        boxShadow: '0px 10px 20px 5px rgba(255, 255, 255, 0.2)'
    };

    const footerButtonStyle = {
        display: 'inline-block',
        padding: '0px 20px',
        width: '50%'
    };

    const footerButtonContainerStyle = {
        display: 'flex',
        justifyContent: 'space-evenly',
        position: 'fixed', left: '0',
        bottom: '0', width: '100%',
        zIndex: '1'
    };

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset',
                color: '#ffffff'
            },
            "& .MuiInputLabel": {
                color: '#ffffff'
            },
            '& .MuiInput-root::after': {
                borderBottom: '2px solid #ffffff'
            },
            '& .MuiInputBase-input-MuiInput-input': {
                color: '#ffffff'
            },
            '& .Mui-focused': {
                color: '#ffffff !important'
            },
            '& .MuiInputBase-root': {
                color: '#ffffff !important'
            }
        }
    }));

    const classes = useStyles();

    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };

    const useRadioStyles = makeStyles({
        root: {
            '&.Mui-checked': {
                color: '#ffffff', // رنگ دایره انتخاب شده
            },
            '&.MuiRadio-colorPrimary':{
                color: '#ffffff !important',
            } // رنگ دایره انتخاب نشده
        },
    });

    function CustomRadio(props) {
        const radioItem = useRadioStyles();
        return <Radio className={radioItem.root} {...props} />;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setOpen(true);
        axios.post('/api/v1/Stuff/AddCustomerStuffSerialNumber', {
            customerId: getAuthenticationToken().userID,
            serialNumber: serialCode,
            customerType: customerType
        }).then(response => {
            setMessageNotify({
                severity: response.data.success ? "success" : "warning",
                message: response.data.warningMessage,
                open: true
            });
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در ثبت شماره سریال",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }

    return (
        <>
            <div style={{ margin: '30px', textAlign: 'center' }}>
                جهت فعال سازی <span style={{ color: '#ffff00', fontSize: 'large' }}>گارانتی <span style={{ fontSize: 'x-large' }}>24</span> ماهه</span> و کسب امتیاز لطفا شماره سریال روی محصول را وارد نمادید
            </div>
            <form onSubmit={handleSubmit}>
                <Grid>
                    <div style={paperStyle}>
                        <TextField
                            style={formElementStyle}
                            className={classes.root}
                            id="postalCode"
                            name="postalCode"
                            label="کد سریال محصول"
                            fullWidth
                            variant="standard"
                            value={serialCode}
                            onChange={e => setSerialCode(e.target.value)} />
                    </div>
                </Grid>

                <Grid item xs={12} sm={12} style={{ margin: '20px' }}>
                    <FormLabel id="demo-row-radio-buttons-group-label" style={{ color: '#ffffff', fontSize: '1.3rem' }}>لطفا انتخاب کنید</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        onChange={e => setCustomerType(e.target.value)}
                        defaultValue={"0"}
                    >
                        <FormControlLabel value="0" control={<CustomRadio selec />} label="خریدار محصولات NEC هستم" />
                        <FormControlLabel value="1" control={<CustomRadio />} label="فروشنده محصولات NEC هستم" />
                    </RadioGroup>
                </Grid>
                <div style={footerButtonContainerStyle}>
                    <div style={footerButtonStyle}>
                        <Button
                            id="submit"
                            type='submit'
                            name="submit"
                            variant="contained"
                            color="success"
                            fullWidth
                            style={formButtonElementStyle}>ثبت</Button>
                    </div>
                    <div style={footerButtonStyle}>
                        <Button
                            onClick={() => { props.history.push('/') }}
                            id="cancel"
                            name="cancel"
                            variant="contained"
                            color="success"
                            fullWidth
                            style={formButtonElementStyle}>انصراف</Button>
                    </div>
                </div>
            </form>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default withRouter(CustomerAddToolsSerialForm);